import {
  FETCH_USERS_AND_GROUPS_INIT, FETCH_USERS_AND_GROUPS_DONE, FETCH_USERS_AND_GROUPS_FAILED,
  MAKE_OR_REMOVE_ADMIN_INIT, MAKE_OR_REMOVE_ADMIN_DONE, MAKE_OR_REMOVE_ADMIN_FAILED,
  REMOVE_USER_DONE, REMOVE_USER_FAILED, REMOVE_USER_INIT,
  INVITE_EMAIL_DONE, INVITE_EMAIL_INIT, INVITE_EMAIL_FAILED,
  FETCH_TASKS_ASSIGNED_DONE, FETCH_TASKS_ASSIGNED_INIT, FETCH_TASKS_ASSIGNED_FAILED,
  SYNC_GSUITE_USERS_DONE, SYNC_GSUITE_USERS_FAILED, SYNC_GSUITE_USERS_INIT,
  SYNC_GSUITE_GROUPS_DONE, SYNC_GSUITE_GROUPS_FAILED, SYNC_GSUITE_GROUPS_INIT, RESET_USERS_PAGINATION,
  CHANGE_USER_ROLE_DONE, CHANGE_USER_ROLE_INIT, CHANGE_USER_ROLE_FAILED, OPEN_ERROR_MODAL, CLOSE_ERROR_MODAL, 
  INVITE_EMAIL_WITH_INBOX_INIT, INVITE_EMAIL_WITH_INBOX_DONE
} from '../actions/types';
import { getSortedUsersWithAvatarColors, handleInvitedUser, userListSort } from 'h-commons';
import uniqBy from 'lodash/uniqBy';

const INIT_USERS_PAGINATION = {
  lastId: 0, total: 0, limit: 50, done: false
};

const initialState = {
  users: [],
  groups: [],
  non_users: [],
  usersWithOpenTasks: {},
  isLoading: false,
  usersPagination: INIT_USERS_PAGINATION,
  isLoadingModalOpen: false,
  failedData:{ openErrorModal: { isOpen: false, type: ''} }
};
/**
 * Saves all users and groups associated with the UG
 * @param {Object} state Default empty state
 * @param {Object} action Action dispached from AC
 */
export function usersAndGroups(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS_AND_GROUPS_INIT:
    case MAKE_OR_REMOVE_ADMIN_INIT:
    case REMOVE_USER_INIT:
    case INVITE_EMAIL_INIT:
    case FETCH_TASKS_ASSIGNED_INIT:
    case SYNC_GSUITE_USERS_INIT:
    case SYNC_GSUITE_GROUPS_INIT: 
    case CHANGE_USER_ROLE_INIT:
      return {...state, isLoading: true };
            
    case FETCH_USERS_AND_GROUPS_DONE: { 
      const newUsers = getSortedUsersWithAvatarColors(action.payload)
                    .map(user => {
                      if (user.status === 'pending')
                        user = handleInvitedUser(user);
                      return user;
                    });
      const allUsers = [...newUsers, ...state.users].filter(u => !!u.id).sort(userListSort);
      const users = uniqBy(allUsers, 'id');
      const lastId = newUsers.length > 0 ? newUsers.reduce((prev, curr) => curr.id > prev ? curr.id : prev, 0) : 0;
      const { usersPagination } = state;
      const pagination = {
        lastId,
        total: users.length,
        done: newUsers.length < usersPagination.limit
      }
      return { 
        ...state,
        users,
        usersPagination: { ...state.usersPagination, ...pagination },
        isLoading: false
      };
    }

    case RESET_USERS_PAGINATION: {
        return { ...state, usersPagination: INIT_USERS_PAGINATION };
    }

    case MAKE_OR_REMOVE_ADMIN_DONE: {
      const targets = action.payload.ids;
      const isAdmin = action.payload.isAdmin;
      return { 
        ...state, 
        isLoading: false,
        users: state.users.map(user => {
          if (targets.includes(user.id)) {
            user.isAdmin = isAdmin;
          }
          return user;
        })
      };
    }

    case REMOVE_USER_DONE: {
      const targets = action.payload;
      return {
        ...state, 
        isLoading: false,
        users: state.users.filter(user => !targets.includes(user.id))
      };
    }

    case INVITE_EMAIL_DONE: {
      const emails = action.payload;
      const newUsers = emails.map(email => ({ email, status: 'pending' })).map(handleInvitedUser);
      const users = [ ...state.users, ...newUsers].sort(userListSort);
      return { ...state, users, isLoading: false };
    }

    case FETCH_TASKS_ASSIGNED_DONE: {
      return { ...state, usersWithOpenTasks: action.payload };
    }

    case SYNC_GSUITE_USERS_DONE:
      return { ...state, non_users: action.payload, isLoading: false };

    case SYNC_GSUITE_GROUPS_DONE: 
      return { ...state, groups: getSortedUsersWithAvatarColors(action.payload), isLoading: false };

    case CHANGE_USER_ROLE_DONE: 
      return { ...state, users: state.users.map(user => {
        if (action.payload.hasOwnProperty(user.id)) {
          user.roleid = action.payload[user.id]
          user.rolename = action.role.name
        }
        return user
      }), isLoading: false}

    case OPEN_ERROR_MODAL:
      return {...state, failedData: action.payload }  
  
    case CLOSE_ERROR_MODAL:
      return {...state, failedData: {...action.payload, openErrorModal: { isOpen: false, type:'' }} }  

    case INVITE_EMAIL_WITH_INBOX_INIT:
      return { ...state, isLoadingModalOpen: true }  

    case INVITE_EMAIL_WITH_INBOX_DONE:
      return {...state, isLoadingModalOpen: false }

    case FETCH_USERS_AND_GROUPS_FAILED: 
    case MAKE_OR_REMOVE_ADMIN_FAILED:
    case REMOVE_USER_FAILED:
    case INVITE_EMAIL_FAILED:
    case FETCH_TASKS_ASSIGNED_FAILED:
    case SYNC_GSUITE_USERS_FAILED:
    case SYNC_GSUITE_GROUPS_FAILED:
    case CHANGE_USER_ROLE_FAILED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}